// src/content/edits.js
// v1: template mood boards used by /moods + /moods/:slug
// NOTE: coverImage + imageUrl can be placeholders for now — swap later.

export const edit_CATEGORIES = [
  {
    key: "quiet-authority",
    title: "Quiet Authority",
    subtitle: "Tailored perfection. Tonal calm. Serious without sharp.",
  },
  {
    key: "artful-statement",
    title: "Artful Statement",
    subtitle: "One strong idea — sculptural, bold, still refined.",
  },
];

// helper for placeholder pins
function imgPins(baseTitle, img) {
  return [
    { kind: "image", imageUrl: img, title: `${baseTitle} — detail` , sourceUrl: null },
    { kind: "image", imageUrl: img, title: `${baseTitle} — silhouette`, sourceUrl: null },
    { kind: "image", imageUrl: img, title: `${baseTitle} — texture`, sourceUrl: null },
    { kind: "image", imageUrl: img, title: `${baseTitle} — palette`, sourceUrl: null },
  ];
}

export const MOODBOARDS = [
  /* =========================
     QUIET AUTHORITY (8)
  ========================== */

  {
    slug: "tailored-perfection",
    category: "quiet-authority",
    name: "Tailored Perfection",
    oneLiner: "Clean structure. Crisp lines. No apology.",
    coverImage: "/clothes/topfront.png",
    pins: imgPins("Tailored Perfection", "/clothes/topfront.png"),
  },
  {
    slug: "tonal-layers",
    category: "quiet-authority",
    name: "Tonal Layers",
    oneLiner: "Low contrast layering that reads resolved.",
    coverImage: "/clothes/topback.png",
    pins: imgPins("Tonal Layers", "/clothes/topback.png"),
  },
  {
    slug: "clean-lines",
    category: "quiet-authority",
    name: "Clean Lines",
    oneLiner: "Minimal seams, long lines, visual clarity.",
    coverImage: "/clothes/pants.png",
    pins: imgPins("Clean Lines", "/clothes/pants.png"),
  },
  {
    slug: "matte-minimal",
    category: "quiet-authority",
    name: "Matte Minimal",
    oneLiner: "Matte textures. Quiet finish. Nothing shiny.",
    coverImage: "/clothes/topfront.png",
    pins: imgPins("Matte Minimal", "/clothes/topfront.png"),
  },
  {
    slug: "quiet-power",
    category: "quiet-authority",
    name: "Quiet Power",
    oneLiner: "Grounded proportions. Controlled silhouette.",
    coverImage: "/clothes/topback.png",
    pins: imgPins("Quiet Power", "/clothes/topback.png"),
  },
  {
    slug: "crisp-neutral",
    category: "quiet-authority",
    name: "Crisp Neutral",
    oneLiner: "Neutral palette with sharp finishing.",
    coverImage: "/clothes/pants.png",
    pins: imgPins("Crisp Neutral", "/clothes/pants.png"),
  },
  {
    slug: "longline-ease",
    category: "quiet-authority",
    name: "Longline Ease",
    oneLiner: "Length and drape, still intentional.",
    coverImage: "/clothes/topfront.png",
    pins: imgPins("Longline Ease", "/clothes/topfront.png"),
  },
  {
    slug: "polished-soft",
    category: "quiet-authority",
    name: "Polished Soft",
    oneLiner: "Softness without slouch. Gentle structure.",
    coverImage: "/clothes/topback.png",
    pins: imgPins("Polished Soft", "/clothes/topback.png"),
  },

  /* =========================
     ARTFUL STATEMENT (8)
  ========================== */

  {
    slug: "sculptural-sleeve",
    category: "artful-statement",
    name: "Sculptural Sleeve",
    oneLiner: "One dramatic form, everything else quiet.",
    coverImage: "/clothes/topfront.png",
    pins: imgPins("Sculptural Sleeve", "/clothes/topfront.png"),
  },
  {
    slug: "single-bold-tone",
    category: "artful-statement",
    name: "Single Bold Tone",
    oneLiner: "One colour, fully committed.",
    coverImage: "/clothes/topback.png",
    pins: imgPins("Single Bold Tone", "/clothes/topback.png"),
  },
  {
    slug: "architectural-collar",
    category: "artful-statement",
    name: "Architectural Collar",
    oneLiner: "A neckline that looks like design, not decoration.",
    coverImage: "/clothes/pants.png",
    pins: imgPins("Architectural Collar", "/clothes/pants.png"),
  },
  {
    slug: "rose-gold-accent",
    category: "artful-statement",
    name: "Rose-Gold Accent",
    oneLiner: "Metallic detail used like punctuation.",
    coverImage: "/clothes/topfront.png",
    pins: imgPins("Rose-Gold Accent", "/clothes/topfront.png"),
  },
  {
    slug: "graphic-stripe",
    category: "artful-statement",
    name: "Graphic Stripe",
    oneLiner: "Bold lines, controlled palette.",
    coverImage: "/clothes/topback.png",
    pins: imgPins("Graphic Stripe", "/clothes/topback.png"),
  },
  {
    slug: "dramatic-drape",
    category: "artful-statement",
    name: "Dramatic Drape",
    oneLiner: "Movement and shape without excess.",
    coverImage: "/clothes/pants.png",
    pins: imgPins("Dramatic Drape", "/clothes/pants.png"),
  },
  {
    slug: "volume-top-quiet-bottom",
    category: "artful-statement",
    name: "Volume Top / Quiet Bottom",
    oneLiner: "One focal area. The rest supportive.",
    coverImage: "/clothes/topfront.png",
    pins: imgPins("Volume Top / Quiet Bottom", "/clothes/topfront.png"),
  },
  {
    slug: "asymmetric-line",
    category: "artful-statement",
    name: "Asymmetric Line",
    oneLiner: "A single unexpected line that reads intentional.",
    coverImage: "/clothes/topback.png",
    pins: imgPins("Asymmetric Line", "/clothes/topback.png"),
  },
];
